import { I18N } from 'aurelia-i18n';
import { autoinject } from 'aurelia-framework';

@autoinject()
export class TurnAroundTimeValueConverter {
    constructor(private readonly i18n: I18N) { }

    public toView(value: any, count: number): any {
        if(value === null || value === undefined) {
            return null;
        }

        if(!count) {
            count = 1000;
        }

        switch(value) {
            case "H": {
                return this.i18n.tr('ui:timespans.hours.$', { 'count': count });
            }
            case "B": {
                return this.i18n.tr('ui:timespans.businessDays.$', { 'count': count });
            }
            case "C": {
                return this.i18n.tr('ui:timespans.days.$', { 'count': count });
            }
            case "S": {
                return this.i18n.tr('ui:timespans.businessDaysWSaturday.$', { 'count': count });
            }
            case "R": {
                return this.i18n.tr('ui:timespans.businessHours.$', { 'count': count });
            }
            default: {
                return "";
            }
        }
    }
}
